<div class="ct-console" #ctnContainer>
  <!-- ── Console Top Bar ──────────────────────────────────────────────────── -->
  <div class="ct-console__topbar d-flex align-items-center gap-2">
    <span class="ct-console__led ct-console__led--green"></span>
    <span class="ct-console__led ct-console__led--amber"></span>
    <span class="ct-console__led ct-console__led--red"></span>
    <span class="ct-console__topbar-title ms-2">BATTLE LOG</span>
    <span class="ct-console__topbar-badge ms-auto">{{ tab | uppercase }}</span>
  </div>

  <!-- ── Divider ───────────────────────────────────────────────────────────── -->
  <div class="ct-console__divider d-flex align-items-center gap-2 my-2">
    <span class="ct-console__divider-line flex-grow-1"></span>
    <span class="ct-console__divider-label">SYS·CHALLENGES</span>
    <span class="ct-console__divider-line flex-grow-1"></span>
  </div>

  <!-- ── Screen Bezel ──────────────────────────────────────────────────────── -->
  <div class="ct-console__bezel">
    <span class="ct-console__screw ct-console__screw--tl"></span>
    <span class="ct-console__screw ct-console__screw--tr"></span>
    <span class="ct-console__screw ct-console__screw--bl"></span>
    <span class="ct-console__screw ct-console__screw--br"></span>

    <div class="ct-console__screen">
      <div class="ct-console__scanlines" aria-hidden="true"></div>

      <!-- ── Responsive Table Wrapper ─────────────────────────────────────── -->
      <div class="table-responsive ct-console__table-wrap">
        <table class="ct-table w-100">
          <thead>
            <tr class="ct-table__head-row">
              <th class="ct-table__th ct-table__th--status">
                {{ 'CHALLENGES.STATUS_TITLE' | translate }}
              </th>
              <th class="ct-table__th ct-table__th--rate">
                {{ 'CHALLENGES.RATE_TITLE' | translate }}
              </th>
              <th class="ct-table__th ct-table__th--player">
                {{ 'CHALLENGES.INITIATOR_TITLE' | translate }}
              </th>
              <th class="ct-table__th ct-table__th--player">
                {{ 'CHALLENGES.OPPONENT_TITLE' | translate }}
              </th>
              <th class="ct-table__th ct-table__th--desc">
                {{ 'CHALLENGES.DESCRIPTION_TITLE' | translate }}
              </th>
              <th
                class="ct-table__th ct-table__th--action"
                *ngIf="['ACTIVE', 'AVAILABLE'].includes(tab)"
                [matTooltip]="'CHALLENGES.BET_TITLE' | translate"
              >
                {{ 'CHALLENGES.BET_TITLE' | translate }}
              </th>
              <th
                class="ct-table__th ct-table__th--action"
                *ngIf="'PROPOSALS' === tab"
                [matTooltip]="'CHALLENGES.ACTIONS_TITLE' | translate"
              >
                {{ 'CHALLENGES.ACTIONS_TITLE' | translate }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr
              *ngFor="let challenge of challenges; let i = index; trackBy: trackItem"
              [@listFadeInOut]="challenges.length"
              class="ct-table__row"
              [class.ct-table__row--winner]="
                challenge.winnerId && challenge.winnerId === authHelper.userProfile.cognitoId
              "
              [class.ct-table__row--loser]="
                challenge.winnerId && challenge.winnerId !== authHelper.userProfile.cognitoId
              "
            >
              <!-- Status -->
              <td class="ct-table__td ct-table__td--center">
                <span class="ct-table__status" [matTooltip]="challenge.status | lowercase">
                  <mat-icon [ngClass]="mapChallengeStatusToIcon[challenge.status]">
                    {{ mapChallengeStatusToIcon[challenge.status] }}
                  </mat-icon>
                </span>
              </td>

              <!-- Rate -->
              <td class="ct-table__td">
                <span
                  class="ct-table__rate"
                  [class.ct-table__rate--win]="
                    challenge.winnerId && challenge.winnerId === authHelper.userProfile.cognitoId
                  "
                  [class.ct-table__rate--loss]="
                    challenge.winnerId && challenge.winnerId !== authHelper.userProfile.cognitoId
                  "
                >
                  <span *ngIf="challenge.winnerId">
                    {{ challenge.winnerId === authHelper.userProfile.cognitoId ? '+' : '-' }} </span
                  >{{ challenge.cost }}
                </span>
              </td>

              <!-- Initiator -->
              <td class="ct-table__td">
                <app-user-template
                  class="icon-30"
                  [user]="challenge.initiator"
                  tooltipField="userData.status"
                ></app-user-template>
              </td>

              <!-- Opponent -->
              <td class="ct-table__td">
                <app-user-template
                  class="icon-30"
                  [user]="challenge.opponent"
                  tooltipField="userData.status"
                ></app-user-template>
              </td>

              <!-- Description -->
              <td class="ct-table__td ct-table__td--desc">
                <span class="ct-table__desc">
                  {{
                    'CHALLENGES.' + challenge.type + '_TYPE_DESCRIPTION'
                      | translate
                        : getChallengeTypeTranslateContext({
                            startDate: challenge.startDate,
                            finishDate: challenge.finishDate,
                            data: challenge.data
                          })
                  }}
                </span>
              </td>

              <!-- Bet action -->
              <td class="ct-table__td" *ngIf="['ACTIVE', 'AVAILABLE'].includes(tab)">
                <button
                  *ngIf="
                    challenge.status === 'ACCEPTED' &&
                    Date.now() < challenge.startDate &&
                    authHelper.userProfile.cognitoId !== challenge.opponent.cognitoId &&
                    authHelper.userProfile.cognitoId !== challenge.initiator.cognitoId
                  "
                  class="ct-btn ct-btn--wager"
                  mat-icon-button
                  (click)="makeWager($event, i)"
                  [matTooltip]="'BUTTON.ADD' | translate"
                >
                  <mat-icon>how_to_vote</mat-icon>
                </button>
              </td>

              <!-- Proposal actions -->
              <td class="ct-table__td" *ngIf="'PROPOSALS' === tab">
                <div
                  class="d-flex gap-1"
                  *ngIf="
                    challenge.status === 'PENDING' && authHelper.userProfile.cognitoId === challenge.opponent.cognitoId
                  "
                >
                  <button
                    class="ct-btn ct-btn--accept"
                    mat-icon-button
                    [tabIndex]="-1"
                    (click)="changeChallengeStatus($event, tab, challenge.id, challenge.type, 'ACCEPTED')"
                    [matTooltip]="'BUTTON.ACCEPT' | translate"
                  >
                    <mat-icon>check_circle_outline</mat-icon>
                  </button>
                  <button
                    class="ct-btn ct-btn--reject"
                    mat-icon-button
                    [tabIndex]="-1"
                    (click)="changeChallengeStatus($event, tab, challenge.id, challenge.type, 'REJECTED')"
                    [matTooltip]="'BUTTON.REJECT' | translate"
                  >
                    <mat-icon>remove_circle_outline</mat-icon>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- /.table-responsive -->

      <!-- Empty state -->
      <div
        *ngIf="!challenges.length"
        class="ct-console__empty d-flex flex-column align-items-center justify-content-center py-4 gap-2"
      >
        <mat-icon class="ct-console__empty-icon">sports_esports</mat-icon>
        <span class="ct-console__empty-text">{{ 'CHALLENGES.NO_BATTLES' | translate }}</span>
      </div>
    </div>
    <!-- /.ct-console__screen -->
  </div>
  <!-- /.ct-console__bezel -->
  <!-- ── Load More Sentinel ─────────────────────────────────────────────────── -->
  <div class="ct-console__loader-wrap" #loading>
    <span *ngIf="isLoading && challenges && challenges.length" class="ct-console__loader-label">
      <span class="ct-console__loader-dot"></span>
      {{ 'GENERAL.LOADING' | translate }}…
    </span>
  </div>
</div>
